import { CalloutsWrapper } from "@clipboard-health/ui-components";
import { Box, Skeleton } from "@mui/material";

import { InHomeCommsBannerCallout } from "../../InHome/CommsBanner/Callout";
import { useIsInHomeRedesignEnabled } from "../../InHome/useIsInHomeRedesignEnabled";
import { ActiveNegotiationsCallout } from "./ActiveNegotiationsCallout";
import { BookingRequestsCallout } from "./BookingRequestsCallout";
import { PendingBreakPaymentRequestsCallout } from "./PendingBreakPaymentRequestsCallout";
import { PendingSentHomeRequestsCallout } from "./PendingSentHomeRequestsCallout";
import { ShiftInviteCallout } from "./ShiftInviteCallout";
import { UnverifiedShiftsCallout } from "./UnverifiedShiftsCallout";
import { WorkplaceProposalCallout } from "./WorkplaceProposalCallout";

interface Props {
  shiftInviteCount: number;
  unverifiedShiftsCount: number;
  activeNegotiationsCount: number;
  facilityProposalsCount: number;
  extraWorkedRequestsCount: number;
  sentHomeRequestsCount: number;
  bookingRequestsCount: number;
  isLoadingShiftInvites: boolean;
  isLoadingUnverifiedShifts: boolean;
  isLoadingNegotiations: boolean;
  isLoadingSentHome: boolean;
  isLoadingExtraWorked: boolean;
  isLoadingBookingRequests: boolean;
}

// eslint-disable-next-line complexity
export function WorkerShiftsCalloutsContainer(props: Props) {
  const {
    shiftInviteCount,
    unverifiedShiftsCount,
    activeNegotiationsCount,
    facilityProposalsCount,
    extraWorkedRequestsCount,
    sentHomeRequestsCount,
    bookingRequestsCount,
    isLoadingShiftInvites,
    isLoadingUnverifiedShifts,
    isLoadingNegotiations,
    isLoadingSentHome,
    isLoadingExtraWorked,
    isLoadingBookingRequests,
  } = props;

  const isInHomeRedesignEnabled = useIsInHomeRedesignEnabled();

  const isLoading =
    isLoadingShiftInvites ||
    isLoadingUnverifiedShifts ||
    isLoadingNegotiations ||
    isLoadingSentHome ||
    isLoadingBookingRequests ||
    isLoadingExtraWorked;

  const hasCallouts =
    shiftInviteCount > 0 ||
    unverifiedShiftsCount > 0 ||
    activeNegotiationsCount > 0 ||
    facilityProposalsCount > 0 ||
    extraWorkedRequestsCount > 0 ||
    bookingRequestsCount > 0 ||
    sentHomeRequestsCount > 0 ||
    isInHomeRedesignEnabled;

  return (
    <Box sx={{ marginX: -4 }}>
      {isLoading && (
        <CalloutsWrapper sx={{ paddingX: 4 }}>
          {Array.from({ length: 2 }).map((_, index) => (
            <Skeleton
              // eslint-disable-next-line react/no-array-index-key
              key={`worker-shift-callout-skeleton-${index}`}
              variant="rounded"
              sx={{
                height: 36,
                width: "60%",
              }}
              aria-label="Loading shift notifications"
            />
          ))}
        </CalloutsWrapper>
      )}
      {!isLoading && hasCallouts && (
        <CalloutsWrapper sx={{ paddingX: 5 }}>
          {isInHomeRedesignEnabled && <InHomeCommsBannerCallout />}
          {shiftInviteCount > 0 && <ShiftInviteCallout shiftInviteCount={shiftInviteCount} />}
          {bookingRequestsCount > 0 && <BookingRequestsCallout />}
          {unverifiedShiftsCount > 0 && (
            <UnverifiedShiftsCallout unverifiedShiftsCount={unverifiedShiftsCount} />
          )}
          {activeNegotiationsCount > 0 && (
            <ActiveNegotiationsCallout activeNegotiationsCount={activeNegotiationsCount} />
          )}
          {facilityProposalsCount > 0 && (
            <WorkplaceProposalCallout facilityProposalsCount={facilityProposalsCount} />
          )}
          {extraWorkedRequestsCount > 0 && (
            <PendingBreakPaymentRequestsCallout
              extraWorkedRequestsCount={extraWorkedRequestsCount}
            />
          )}
          {sentHomeRequestsCount > 0 && (
            <PendingSentHomeRequestsCallout sentHomeRequestsCount={sentHomeRequestsCount} />
          )}
        </CalloutsWrapper>
      )}
    </Box>
  );
}
